<template>
  <div>
    <b-autocomplete
      v-model="payload.reportId"
      :items="$directory.get('reportList')"
      placeholder="оберіть зі списку"
      item-value="id"
      item-title="period"
      label="Звітній період"
      :loading="$loading.isLoading('reportList')"
      :error-messages="getErrorMessages(v$.reportId)"
      @blur="v$.reportId.$touch()">
    </b-autocomplete>
    <b-select
      v-model="payload.statusIds"
      multiple
      :items="$directory.get('packageStatuses')"
      label="Статуси пакетів"
      :loading="$loading.isLoading('packageStatuses')">
      <template #prepend-item>
        <v-list-item title="Обрати всі" @click="toggleStatuses">
          <template #prepend>
            <v-checkbox-btn
              :indeterminate="someStatusesSelected && !allStatusesSelected"
              :model-value="allStatusesSelected"></v-checkbox-btn>
          </template>
        </v-list-item>

        <v-divider class="mt-2"></v-divider>
      </template>
    </b-select>
    <b-select
      v-model="payload.duplicateType"
      :items="$directory.get('debtorReportDuplicateTypes')"
      label="Метод пошуку боржника"
      :error-messages="getErrorMessages(v$.duplicateType)"
      @blur="v$.duplicateType.$touch()"></b-select>
  </div>
</template>

<script lang="ts">
import { fillDirectory, getDirectory } from '@/directory'
import { computed, reactive } from 'vue'
import { required } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'
import { getErrorMessages } from 'best-modules/utils'
import { debtorDuplicatesReport } from '@/request/report'

export default {
  name: 'DebtorDuplicates',
  methods: { getErrorMessages },
  setup() {
    fillDirectory(['reportList', 'packageStatuses'])

    const payload = reactive({
      reportId: null,
      statusIds: [],
      duplicateType: null,
    })

    const rules = {
      reportId: { required },
      duplicateType: { required },
    }
    const v$ = useVuelidate(rules, payload)

    const submit = () => {
      return debtorDuplicatesReport(payload)
    }

    const allStatusesSelected = computed<boolean>(() => {
      return payload.statusIds.length === getDirectory('packageStatuses').length
    })
    const someStatusesSelected = computed<boolean>(() => {
      return !!payload.statusIds.length
    })

    const toggleStatuses = () => {
      if (allStatusesSelected.value) {
        payload.statusIds = []
      } else {
        payload.statusIds = getDirectory('packageStatuses').map(s => s.id)
      }
    }

    return {
      payload,
      v$,
      submit,
      allStatusesSelected,
      someStatusesSelected,
      toggleStatuses,
    }
  },
}
</script>

<style scoped lang="scss"></style>
